import * as React from 'react';

function SvgSwapVertical(props: ISvgIcons) {
  return (
    <svg
      width={props.size}
      height={props.size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={'0 0 24 24'}
      {...props}
    >
      <g
        stroke={props.color}
        strokeWidth={props.weight}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={'non-scaling-stroke'}
      >
        <path d="M9.752.75v20.689a.751.751 0 01-1.281.531L4.5 18M19.5 6l-3.968-3.97a.75.75 0 00-1.28.531V23.25" />
      </g>
    </svg>
  );
}

export default SvgSwapVertical;
